// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CustomTable_tableWrapper__5Os0x"};